import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
    __gaScriptInjected?: boolean;
  }
}

type RouteAnalyticsProps = {
  measurementId?: string;
};

export default function RouteAnalytics({ measurementId }: RouteAnalyticsProps) {
  const location = useLocation();

  // Initialize Google tag (gtag.js) once using the provided measurement ID
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (!measurementId) return;

    if (!window.__gaScriptInjected) {
      // Mirror the official gtag snippet behavior
      window.dataLayer = window.dataLayer || [];
      const gtag = function(..._args: any[]) {
        (window.dataLayer as any[]).push(arguments as any);
      };
      window.gtag = gtag as any;

      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      document.head.appendChild(script);

      if (typeof window.gtag === "function") {
        window.gtag("js", new Date());
        // Disable automatic page_view; we'll send on route changes to avoid double counts
        window.gtag("config", measurementId, { send_page_view: false });
      }

      window.__gaScriptInjected = true;
    }
  }, [measurementId]);

  // Send a page_view event on route changes
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (typeof window.gtag !== "function") return;
    const path = window.location.pathname + window.location.search + window.location.hash;
    const title = document.title;
    window.gtag("event", "page_view", {
      page_path: path,
      page_title: title,
      send_to: measurementId,
    });
  }, [location.pathname, location.search, location.hash, measurementId]);

  return null;
}


